// Force a file to download to the desktop. Cloudinary/GridFS URLs are public,
// but the anchor `download` attribute is ignored for cross-origin URLs — so we
// fetch the bytes into a blob and save that. Falls back to opening the URL if
// the fetch is blocked by CORS.
export async function downloadFile(url, filename) {
  if (!url) return;
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename || inferName(url);
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (err) {
    console.warn('Blob download failed, opening directly:', err);
    window.open(url, '_blank', 'noopener');
  }
}

function inferName(url) {
  try {
    const path = new URL(url).pathname;
    const last = path.split('/').pop();
    return last || 'download';
  } catch {
    return 'download';
  }
}
